import React from 'react';
import { TipsMapType } from '..';
import { CONTACT_EMAIL } from '@op/constants';

export const gptLanguageTipsText: TipsMapType = {
  en: (
    <>
      According to different language prompts, there may be slight differences
      in the report content of different languages ​​returned by GPT.
    </>
  ),
  zh: (
    <>根据不同语种Prompt的不同，GPT返回的不同语种的报告内容可能存在细微差异。</>
  ),
};

export const gptSubGameNotSupportTipsText: TipsMapType = {
  en: (
    <>
      This feature is not currently supported in the sub-version of the game. If
      you need it, please contact {CONTACT_EMAIL}.
    </>
  ),
  zh: <>子版本游戏暂不支持该功能，如果有需要请联系{CONTACT_EMAIL}。</>,
};
